<template>
    <v-layout row justify-center v-if="visible">
        <v-card elevation="0" style="max-width: 600px;">
            <v-card-title>
                <h3>{{ $t("edgeTrimmer") }}</h3>
            </v-card-title>
            <v-card-text>
                 <v-layout wrap>
                    <v-flex xs12 sm6 pa-2>
                        <v-layout wrap>
                            <v-flex xs12 sm6 pa-2>
                                <v-text-field
                                    :label="`${$t('maxSawsAmount')}`"
                                    :hint="$t('maxSawsAmount')"
                                    :rules="[rules.required, rules.maxAmount]"
                                    v-model="maxAmount.val"
                                    ref="maxSaws"
                                    required
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 pa-2>
                                <v-text-field
                                    :label="$t('kerf')"
                                    :hint="`${$t('kerf')}, ${$t('mm')}`"
                                    :suffix="$t('mm')"
                                    :rules="[rules.required, rules.kerf]"
                                    v-model="kerf.val"
                                    ref="kerf"
                                    required
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 sm6 pa-2>
                        <v-layout wrap>
                            <v-flex xs12 py-0>
                                <v-checkbox
                                    v-model="twoRows"
                                    :label="`${$t('twoRowsAfterFrame')}`"
                                ></v-checkbox>
                            </v-flex>
                            <v-flex xs12 py-0>
                                <v-checkbox
                                    v-model="optimizeByWidth"
                                    :label="`${$t('optimizationByWidth')}`"
                                ></v-checkbox>
                            </v-flex>
                            <!--
                            <v-flex xs12 py-0>
                                <v-checkbox
                                    v-model="sameWidth"
                                    :label="`${$t('sameWidthSides')}`"
                                ></v-checkbox>
                            </v-flex>
                            -->
                        </v-layout>
                    </v-flex>
                 </v-layout>
            </v-card-text>
        </v-card>
    </v-layout>
</template>

<script>
    export default {
        name: "EdgeTrimmerSettings",

        data () {
            return {
                changed: false,
                checkingInput: false,
                disableWatch: false,
                maxAmount: { val: 0, min: 0, max: 0 },
                kerf: { val: 0, min: 0, max: 0 },
                optimizeByWidth: false,
                sameWidth: false,
                twoRows: false,
                rules: {
                    required:  value => !!value || this.$t("requiredField"),
                    maxAmount: value => (value >= this.maxAmount.min && value <= this.maxAmount.max) || this.$t("incorrectValue"),
                    kerf:      value => (value >= this.kerf.min && value <= this.kerf.max) || this.$t("incorrectValue")
                },
                visible: false
            }
        },

        watch: {
            optimizeByWidth: function () { this.changed = !this.disableWatch ? true : this.changed; },
            sameWidth:       function () { this.changed = !this.disableWatch ? true : this.changed; },
            twoRows:         function () { this.changed = !this.disableWatch ? true : this.changed; },
            visible:         function (val) { this.changed = val ? false : this.changed; }
        },

        methods: {
        }
    }
</script>
